var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoiler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.702 10.164C20.874 9.98401 23.052 9.92401 25.23 9.88201C26.058 9.77401 26.988 10.182 27.276 11.022C27.42 11.364 27.378 11.838 27.378 12.204C27.366 13.26 27.36 14.418 27.318 15.468C27.27 16.746 27.204 18.564 27.09 19.818C26.892 17.352 26.814 14.676 26.796 12.204C26.874 11.076 26.49 10.374 25.23 10.446C23.052 10.404 20.88 10.338 18.702 10.164Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.702 5.664C21.852 5.484 25.008 5.424 28.158 5.382C30.438 5.292 32.562 7.176 32.718 9.462C32.76 10.428 32.694 11.682 32.688 12.642C32.634 14.49 32.58 17.124 32.46 18.948C32.346 17.136 32.274 14.484 32.232 12.642C32.19 11.604 32.214 10.512 32.16 9.516C31.98 7.524 30.168 5.91 28.164 5.946C25.008 5.904 21.858 5.838 18.708 5.664H18.702Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.174 16.866H14.826C13.5966 16.866 12.6 17.8626 12.6 19.092V52.116C12.6 53.3454 13.5966 54.342 14.826 54.342H45.174C46.4034 54.342 47.4 53.3454 47.4 52.116V19.092C47.4 17.8626 46.4034 16.866 45.174 16.866Z",
    fill: "#FFF4DE",
    stroke: "#FFF4DE",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.174 36.516H14.826C13.5966 36.516 12.6 37.5126 12.6 38.742V52.11C12.6 53.3394 13.5966 54.336 14.826 54.336H45.174C46.4034 54.336 47.4 53.3394 47.4 52.11V38.742C47.4 37.5126 46.4034 36.516 45.174 36.516Z",
    fill: "#E5DBCA",
    stroke: "#E5DBCA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.992 43.92V45.336H18.732V43.92C18 44.178 17.466 44.874 17.466 45.696C17.466 46.74 18.312 47.592 19.362 47.592C20.412 47.592 21.258 46.746 21.258 45.696C21.258 44.874 20.73 44.178 19.992 43.92Z",
    fill: "#17292C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.01 43.944C20.076 44.574 20.19 45.006 20.208 45.522L19.992 45.54C19.488 45.582 18.978 45.594 18.474 45.606C18.456 45.048 18.45 44.484 18.516 43.92L18.798 44.124C16.788 44.652 17.46 47.37 19.356 47.304C21.18 47.16 21.546 44.832 20.004 43.944H20.01ZM19.974 43.896C22.38 44.4 21.804 47.964 19.362 47.88C17.088 47.838 16.668 44.616 18.66 43.716L18.906 43.602L18.942 43.92C18.996 44.394 19.008 44.862 18.99 45.336L18.726 45.072C19.146 45.078 19.566 45.096 19.986 45.132L19.782 45.336C19.812 44.802 19.914 44.298 19.968 43.896H19.974Z",
    fill: "#17292C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.998C27.144 40.998 24.828 43.314 24.828 46.17C24.828 49.026 27.144 51.342 30 51.342C32.856 51.342 35.172 49.026 35.172 46.17C35.172 43.314 32.856 40.998 30 40.998ZM33.294 45.294C33.294 45.726 32.94 46.08 32.508 46.08H27.492C27.06 46.08 26.706 45.726 26.706 45.294V44.472C26.706 44.04 27.06 43.686 27.492 43.686H32.508C32.94 43.686 33.294 44.04 33.294 44.472V45.294Z",
    fill: "#17292C",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.426 44.076H37.674",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.288 45.912H37.674",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.288 47.754H37.674",
    stroke: "#17292C",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.566 19.308C28.554 19.164 28.722 19.086 28.824 19.182C35.154 25.458 36.162 28.104 36.042 31.572C35.928 34.722 32.958 37.584 29.73 37.584C26.502 37.584 23.856 35.094 23.952 32.16C24.174 25.53 29.112 24.63 28.566 19.308Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.214 26.034C32.994 29.748 33.588 31.278 33.522 33.294C33.456 35.094 31.758 36.732 29.916 36.732C28.074 36.732 26.556 35.304 26.61 33.63C26.736 29.742 29.712 29.298 29.214 26.034Z",
    fill: "#FF931E",
    stroke: "#FF931E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoiler);
export default __webpack_public_path__ + "static/media/boiler.0b3950155de9d4972795cd421899ec39.svg";
export { ForwardRef as ReactComponent };